
import firebase from "firebase/app";
import "firebase/messaging";
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import AppRoute from "./Routes";
import { history } from "./Redux/Store";

import MobileView from "./Components/MobileView/mobileView";
import "./assets/bootstrap.min.css";
import "./assets/metisMenu.min.css";
import "./assets/app.min.css";
// import ClearCache from './clearCache';

const App = () => {
  const [isCheckoutRoute, setIsCheckoutRoute] = useState(false);
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath==="/Payment/Checkout") {
      setIsCheckoutRoute(true);
    } else {
      setIsCheckoutRoute(false);
    }
  }, []);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth > 768 ? false : true
  );

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768); // Set breakpoint at 768px
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (firebase.messaging.isSupported()) {
    navigator.serviceWorker.addEventListener("message", (event) => {
      const { targetUrl } = event.data;
      if (targetUrl) {
        window.location.href = targetUrl;
      }
      if (event?.data?.action == "notfication_click") {
        window.location.href = event?.data?.url;
      }else if(event?.data?.action == "awaiting_response"){
        localStorage.setItem("ErroredJobUrl", event?.data.data);
        window.location.href = event?.data?.url;
      }   
    });
  }
  

  const broadcast = new BroadcastChannel("count-channel");
  broadcast.onmessage = (event) => {
    if (
      event?.data?.payload?.data?.type == "PAYMENT_COMPLETE" ||
      event?.data?.payload?.data?.type == "PAYMENT_FAILED"
    ) {
      history.push(`/home`);
      window.location.reload();
    }
  };

  return (
    <>
      {/* <ClearCache /> */}
      {isMobile && !isCheckoutRoute && window.location.pathname !== "/biometricTracking" && window.location.pathname !== "/biometricCheckout" ? (
        <div>
          <MobileView />
        </div>
      ) : (
        <>
          <AppRoute />
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default App;
